import*as React from"react";import styled from"@emotion/styled";import{AntdDateRangePicker}from"@wp/src/components/common/datePicker";const StyledDateRangePicker=styled(AntdDateRangePicker)`
  .ant-picker-input {
    & > input {
      width: 100px;
    }
  }
`;export const DateRangePicker=props=>{const{startDate,endDate,setSelectedDates,format,disabledDate,style}=props;const dates=[startDate||null,endDate||null];const onChange=dates=>{if(dates)setSelectedDates(dates[0],dates[1])};return React.createElement(StyledDateRangePicker,{size:"large",style:style,value:dates,onChange:onChange,format:format,disabledDate:disabledDate})};